import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({ title: "User Summary Config" })
export default class PanelConfig {
	@Input({ type: InputType.CHECKBOX, title: "Show User Avatar" })
	public showAvatar: boolean = true;

	@Input({ type: InputType.CHECKBOX, title: "Show Certificates" })
	public showCertificates: boolean = true;

	@Input({
		type: InputType.CHECKBOX,
		title: "Show Continue Last Launched Button"
	})
	public showLastLaunched: boolean = true;

	@Input({ type: InputType.CHECKBOX, title: "Show Last Login" })
	public showLastLogin: boolean = true;

	@Input({ type: InputType.CHECKBOX, title: "Show Total Credits" })
	public showTotalCredits: boolean = true;

	@Input({ type: InputType.TEXT, title: "Default Profile Image URL" })
	public defaultAvatarUrl: string;

	@Input({ type: InputType.CHECKBOX, title: "Show User Details" })
	public showUserDetails: boolean = true;

	@Input({ type: InputType.PAGE_PATH, title: "Does this work?" })
	public pagePath?: string[];
}



// WEBPACK FOOTER //
// ./src/panels/userSummary/Config.ts